import { useState } from 'react';
import NudosDatePicker from '../../../../../components/NudosComponents/NudosDatePicker';
import { IlogisticServiceDetails, IlogisticServiceTrelloCardData } from '../../../../../types/services';
import LogisticsServiceTrelloCard from '../../LogisticsServiceTrelloCard/LogisticsServiceTrelloCard';
import { NudosButton } from '../../../../../components/NudosComponents';
import { TchangeLogisticServiceStatusCallback } from '../LogisticsServicesTrelloModals';
import { getNudosData } from '../../../../../utils/getNudosData';
import './DeliveredLogisticsModal.scss';

const DeliveredLogisticsModalContent = ({
  selectedLogisticServiceDataForModal,
  logisticServiceDetails,
  changeLogisticServiceStatusCallback,
  closeModalAfterSubmitCallback,
  modalButtonIsLoading
}: {
  selectedLogisticServiceDataForModal: IlogisticServiceTrelloCardData;
  logisticServiceDetails?: IlogisticServiceDetails;
  changeLogisticServiceStatusCallback: TchangeLogisticServiceStatusCallback;
  closeModalAfterSubmitCallback: () => void;
  modalButtonIsLoading?: boolean;
}) => {
  const [deliveryDate, setDeliveryDate] = useState<string>();

  const submitModal = () => {
    const currentNudosUser = getNudosData();
    if (!currentNudosUser?.userData?.id) return;
    const body = { userId: currentNudosUser?.userData?.id, status: 'entregado', delivered: { deliveryDate } };
    changeLogisticServiceStatusCallback(body, closeModalAfterSubmitCallback);
  };

  return (
    <div className="DeliveredLogisticsModalContent">
      <h3 className="deliveredSubtitle">Estás a punto de actualizar el estado del siguiente servicio:</h3>
      <LogisticsServiceTrelloCard logisticServiceData={selectedLogisticServiceDataForModal} />
      <NudosDatePicker
        componentSize="medium"
        label="Fecha de entrega"
        updateCurrentValueCallback={setDeliveryDate}
        isFilled={!!deliveryDate}
        desiredTimeZone={-6} // Zona Horaria de México por definición
      />
      <NudosButton
        componentSize="large"
        buttonText="Guardar"
        isButtonDisabled={!deliveryDate}
        handleClick={submitModal}
        isButtonLoading={modalButtonIsLoading}
      />
    </div>
  );
};

export default DeliveredLogisticsModalContent;
